(function () {
  document.querySelectorAll('[tab-controller]').forEach((button) => {
    button.addEventListener('click', async () => {
      const collectionHandle = button.getAttribute('data-collection');
      const sectionId = button.getAttribute('data-section-id');

      const list = document.querySelector(`ul[data-id="${sectionId}"]`);
      const productsToShow = parseInt(list.getAttribute('product-to-show'), 10);

      const collectionHTML = await fetchCollectionHTML(collectionHandle);

      if (list) {
        list.innerHTML = '';

        const parser = new DOMParser();
        const doc = parser.parseFromString(collectionHTML, 'text/html');
        const items = doc.querySelectorAll('.card-wrapper.product-card-wrapper');

        items.forEach((item, index) => {
          if (index < productsToShow) {
            const newLi = document.createElement('li');
            newLi.id = `Slide-${sectionId}-${index + 1}`;
            newLi.className = `grid__item slider__slide scroll-trigger animate--slide-in`;
            newLi.setAttribute('data-cascade', '');
            newLi.style.setProperty('--animation-order', index + 1);

            // Use outerHTML so the .card-wrapper div itself is preserved.
            // This keeps the correct DOM structure for CSS, product links,
            // and allows custom elements (quick-add-modal, modal-opener) to
            // be properly instantiated by the browser when inserted into the DOM.
            newLi.innerHTML = item.outerHTML;
            list.appendChild(newLi);
          }
        });

        document.dispatchEvent(
          new CustomEvent('need_update', {
            detail: { sectionId },
          })
        );
      } else {
        console.error('List element not found');
      }

      document.querySelectorAll('[tab-controller]').forEach((btn) => {
        btn.classList.remove('current');
      });
      button.classList.add('current');
    });
  });

  async function fetchCollectionHTML(collectionHandle) {
    const response = await fetch(`/collections/${collectionHandle}`);

    if (!response.ok) {
      console.error(`Error fetching collection: ${response.statusText}`);
      return '';
    }

    const text = await response.text();
    return text;
  }
})();
